import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import useAxios from './useAxios';
import useSubscriber from './useSubscriber';

export interface ChatStats {
    totalActive: number;
    chats: Array<{
        fanId: number;
        fanUsername: string | null;
        startedAt: Date;
        lastActivity: Date;
        expiresIn: number;
    }>;
}

const useMessageUsersAutoCurrentChatToListStats = () => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const { data: subscriber } = useSubscriber();
    const axios = useAxios();

    const fetchData = async (): Promise<ChatStats> => {
        const query: string = `${settingsContext.routes.messageUsers.base}${subscriber._id}/autoCurrentChatToList/stats`;

        return axios
            .get(query)
            .then(response => response.data)
            .catch(() => {
                return {
                    totalActive: 0,
                    chats: [],
                };
            });
    };

    const query = useQuery(['messageUsersAutoCurrentChatToListStats', subscriber?._id], () => fetchData(), {
        refetchOnWindowFocus: false,
        // 1 minute
        refetchInterval: 30000,
        // 5 minutes
        cacheTime: 300000,
        enabled: userContext.jwtToken && settingsContext.apiKey && subscriber && subscriber._id ? true : false,
    });

    return { ...query };
};

export default useMessageUsersAutoCurrentChatToListStats;
